module.exports = __webpack_public_path__ + "static/media/BillionDollarGirl.ab261c44.jpg";